import { render, staticRenderFns } from "./management-library-department-category-form.vue?vue&type=template&id=2674e2da"
import script from "./management-library-department-category-form.vue?vue&type=script&lang=js"
export * from "./management-library-department-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports